export enum ClinicTaskStatus {
  Open = 10,
  'In Progress' = 20,
  Resolved = 30,
}
